export default __webpack_public_path__ + "static/media/TTR_Loading_2.5f74f79a.gif";